export default class Backend {
	constructor(_app, url) {
		this._url = url;
	}

	get(path) {
		return webix.ajax(this._url + path).then(a => a.json());
	}
	save(path, data, mode) {
		let x = webix.ajax().headers({ "Content-type": "application/json" });
		if (mode == 0) x = x.post(this._url + path, data);
		if (mode == 1) x = x.del(this._url + path, data);
		if (mode == 2) x = x.put(this._url + path, data);
		return x.then(a => a.json());
	}

	users() {
		return this.get("users");
	}
	addUser(data) {
		return this.save("users", data, 0);
	}
	deleteUser(id) {
		return this.save("users/" + id, {}, 1);
	}
	updateUser(id, data) {
		return this.save("users/" + id, data, 2);
	}

	roles() {
		return this.get("roles");
	}
	addRole(data) {
		return this.save("roles", data, 0);
	}
	deleteRole(id) {
		return this.save("roles/" + id, {}, 1);
	}
	updateRole(id, data) {
		return this.save("roles/" + id, data, 2);
	}

	rules() {
		return this.get("rules");
	}
	meta() {
		return this.get("meta");
	}

	avatar(id) {
		return this._url + `users/${id}/avatar`;
	}

	credentials(id) {
		return this.get(`user/${id}/credentials`);
	}
	addCredentials(id, data) {
		return this.save(`user/${id}/credentials`, data, 0);
	}
	resetPassword(id, data) {
		return this.save(`user/${id}/credentials`, data, 2);
	}
	deleteCredentials(id, credId) {
		return this.save(`user/${id}/credentials/${credId}`, {}, 1);
	}

	logs(type, id) {
		return this.get(`logs/${type}/${id}`);
	}
	logsMeta() {
		return this.get("logs/meta");
	}
}
